<script setup>

import NavigationModalMobile from "@/components/NavigationModalMobile.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import {ref} from "vue";
import BackSvg from "@/components/UI/svg/BackSvg.vue";


const isMenuVisible = ref(false)

const selectedItem = ref('popular')

const studyItems = ref([
    { id: 'popular', name: 'Самые популярные' },
    { id: 'recommended', name: 'Рекомендуем' }
])

const integrationItems = ref([
    { id: 'google-sheets', name: 'Google Sheets' },
    { id: 'yandex-direct', name: 'Yandex Direct' },
    { id: 'yandex-tables', name: 'Yandex Таблицы' }
])

const items = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20])

</script>

<template>
    <div class="flex h-screen w-full overflow-y-hidden">
        <NavigationBar/>
        <NavigationModalMobile v-model="isMenuVisible" />
        <div class="w-full h-full flex flex-col">
            <!-- Верхняя панель (фиксированная) -->
            <div class="w-full h-20 border-b flex items-center justify-start px-4 flex-shrink-0">
                <div class="text-lg">
                    Изучите интеграции
                </div>
            </div>

            <div class="w-full flex-1 overflow-y-hidden flex">
                <div class="w-1/4 border h-full overflow-y-auto">
                    <div class="p-4">
                        <div class="mb-2 text-2xl font-bold">Изучите</div>
                        <div
                            v-for="item in studyItems"
                            :key="item.id"
                            @click="selectedItem = item.id"
                            class="mb-2 cursor-pointer transition-colors font-bold text-blue-600"
                            :class="[
                              selectedItem === item.id
                                ? 'selected-button'
                                : 'unselected-button',
                            ]"
                        >
                            {{ item.name }}
                        </div>

                        <div class="mb-2 text-2xl font-bold mt-4">Интеграции</div>
                        <div class="mb-2 text-xl">Соединения</div>

                        <div
                            v-for="item in integrationItems"
                            :key="item.id"
                            @click="selectedItem = item.id"
                            class="mb-2 cursor-pointer transition-colors"
                            :class="[
                              selectedItem === item.id
                                ? 'selected-button'
                                : 'unselected-button',
                            ]"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>

                <div class="w-3/4 border flex flex-col p-4 overflow-y-auto ">
                    <div class="mb-4 text-lg font-semibold flex-shrink-0">
                        Самые популярные интеграции
                    </div>

                    <div class="flex-1">
                        <div class="flex flex-wrap gap-4">
                            <div
                                v-for="item in items"
                                v-bind:key="item"
                                class="min-w-[350px] flex-1"
                            >
                                <div class="flex flex-col border h-52 bg-gray-50 rounded hover:shadow-lg transition-shadow">
                                    <div class="flex-1">
                                        <div class="w-full h-full flex">
                                            <div class="flex items-center justify-between w-full h-full mx-5 mr-10">
                                                <div>
                                                    <div class="font-medium">Интеграция {{ item }}</div>
                                                    <div class="text-sm text-gray-500 mt-2">Описание интеграции</div>
                                                </div>

                                                <div class="size-24 bg-blue-100 rounded-full">

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="border-t w-full h-12 flex items-center">
                                        <div class="w-fit ml-auto rounded-sm hover:bg-blue-50 flex items-center justify-center cursor-pointer gap-2 font-bold text-blue-500 text-xs m-5 px-4 py-2 duration-150 transition-all">
                                            <div>
                                                Создайте соединение
                                            </div>
                                            <div>
                                                <BackSvg class="size-4 rotate-180 fill-blue-500" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<style scoped>
.selected-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 0.5rem 1.5rem 0.5rem 1.5rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) /* #e5e7eb */;
}

.unselected-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 0.5rem 1.5rem 0.5rem 1.5rem;
    border-radius: 9999px;

}

.unselected-button:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) /* #e5e7eb */;
}
</style>